module.exports = __webpack_public_path__ + "static/media/icone-covid.2c0e6297.png";